import { CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react';
import { useAppSelector } from 'app/hooks'
import { UnifiedLoader } from 'components/loader';
import { selectLoading } from 'features/loader';
import { selectVisible, selectVisibleSecondary } from 'features/modal';
import React from 'react'
import './ModalBase.scss';

type ModalType = 'edit' | 'delete' | 'permis' | 'principal';

interface ModalBaseProps {
  title: string;
  body: React.ReactNode;
  onClose: () => void;
  size?: string | null;
  type?: string;
}

const modalColors = {
  edit: {
    gradient: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)'
  },
  delete: {
    gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)'
  },
  permis: {
    gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)'
  },
  principal: {
    gradient: 'linear-gradient(135deg, var(--cui-primary) 0%, #1565c0 100%)'
  }
};

export const ModalBase = (props: ModalBaseProps) => {
  const visible = useAppSelector((state) => selectVisible(state));
  const visibleSecondary = useAppSelector((state) => selectVisibleSecondary(state));
  const loading = useAppSelector((state) => selectLoading(state));

  const modalType = (props.type || 'principal') as ModalType;
  const colors = modalColors[modalType] || modalColors.principal;

  const getValidSize = (size?: string | null): 'sm' | 'lg' | 'xl' | undefined => {
    if (!size) return undefined;
    if (size === 'sm' || size === 'lg' || size === 'xl') return size;
    return undefined;
  };

  const modalSize = getValidSize(props.size);
  const isFullscreen = props.size === 'fullscreen';

  const handleClose = () => {
    if (visibleSecondary) return;
    props.onClose();
  };

  return (
    <CModal
      alignment="center"
      visible={visible && !visibleSecondary}
      backdrop="static"
      onClose={handleClose}
      {...(isFullscreen ? { fullscreen: true } : modalSize ? { size: modalSize } : {})}
      scrollable
      className="modal-base"
    >
      <CModalHeader
        className="modal-base-header"
        style={{ background: colors.gradient }}
      >
        <CModalTitle className='text-white fw-bold'>{props.title}</CModalTitle>
      </CModalHeader>
      <CModalBody className="modal-base-body">
        {props.body}
      </CModalBody>
      <CModalFooter className='modal-base-footer justify-content-center'>
        {loading && (
          <UnifiedLoader variant="minimal" size="sm" />
        )}
      </CModalFooter>
    </CModal>
  )
}
